import { render } from "./ListeTypeCargaison.vue?vue&type=template&id=a386d078&ts=true"
import script from "./ListeTypeCargaison.vue?vue&type=script&lang=ts"
export * from "./ListeTypeCargaison.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__